module.exports = __webpack_public_path__ + "img/office-employee.371b48c3.svg";